"use client";

import { FC, useEffect, useState } from "react";
import RssReader from "@/components/RssReader";
import { RssReaderCardType } from "@/components/RssReader/RssReaderCard";
import RSSService from "@/helpers/services/RSS/RSSService";
import { RssSource } from "@/helpers/services/RSS/types";
import { BuilderBlockProps } from "@/types";

type ThreadIntegrationBlockProps = {
  source?: RssSource;
  headline?: string;
  link?: {
    title: string;
    href: string;
    dld?: string;
    dlt?: string;
  };
  limit?: number;
  theme: "white" | "gray";
} & BuilderBlockProps;

export const ThreadIntegrationBlock: FC<ThreadIntegrationBlockProps> = ({
  source,
  headline,
  link,
  limit = 5,
  theme,
  attributes,
}) => {
  const [cards, setCards] = useState<RssReaderCardType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    let isCancelled = false;

    const fetchData = async () => {
      if (!source) {
        setCards([]);
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const parsedCards = await RSSService().fetchData(source, limit);
        if (!isCancelled) {
          setCards(parsedCards);
        }
      } catch (error) {
        console.error("Failed to fetch RSS data:", error);
        if (!isCancelled) {
          setCards([]);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };
    fetchData();
    return () => {
      isCancelled = true;
      setLoading(false);
    };
  }, [source, limit]);

  return (
    <section data-theme={theme} {...attributes}>
      <RssReader
        theme={theme}
        headline={headline}
        cards={cards}
        link={link}
        isLoading={loading}
      />
    </section>
  );
};
